/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import Typography from "../../../../components/common/new/Typography/Typography";
import styles from "../AppointmentSubmission.styles";

function MemberInterviewedForm({ ids, setIds, options }) {
  return (
    <Box my={7}>
      <Box
        style={{
          width: "160px",
          height: "44px",
          flexShrink: "0",
          borderRadius: "35px",
          background: "#196AAB",
          marginBottom: "-25px",
          position: "relative",
          zIndex: "1",
          marginLeft: "45px",
        }}
      >
        <Typography
          variant="title3"
          style={{
            color: "#FFF",
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: "Noto Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "20px",
            padding: "12px 20px 12px 20px",
            margin: "0px",
          }}
        >
          Interaction By
        </Typography>
      </Box>
      <Box
        style={{
          borderRadius: "5px 5px 5px 5px",
          border: "1px solid #C2D4EB",
          background: "#F6F6F6",
          padding: "30px 0px 20px 20px",
          borderBottom: "9px solid #196AAB",
          margin: "0px 20px",
        }}
      >
        <Box style={styles.interviewBy}>
          <Box flex={1}>
            <Typography variant="mini" color="#5e5e5e" weight={600}>
              Interaction By:
              <Typography variant="small" color="#FF6A69">
                *
              </Typography>
            </Typography>
          </Box>
          <Box flex={1} style={{ maxWidth: "80%" }}>
            <Dropdown
              // name="Ids"
              value={ids}
              options={options}
              multiple
              label="Select"
              onChange={(e) =>
                setIds(
                  typeof e.target.value === "string"
                    ? e.target.value.split(",")
                    : e.target.value
                )
              }
              sx={{ background: "#FFF" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default MemberInterviewedForm;
